import Styles from './AccountSkeleton.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const AccountSkeleton = () => (
  <Skeleton
    avatar={{ shape: 'circle', size: 50 }}
    active
    paragraph={{
      rows: 1,
      width: '194px',
      style: { marginTop: '6px', height: '12px', borderRadius: '20px' },
      className: Styles.skeletonParagraph,
    }}
    title={{
      width: '94px',
      style: { marginTop: '10px', height: '12px', borderRadius: '20px' },
    }}
  />
)
